import React from "react";
import { useTranslation } from "react-i18next";

import { Notifications } from "@scenes/notifications";
import { AssistantShortcut } from "@scenes/assistantShortcut";
import { ProfileNavigation } from "@common/profileNavigation";
import { Navigation } from "./navigation";
import { Props } from "./types";
import styles from "./styles.scss";

function Header(props: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.header}>
      <h1 className={styles.title}>{t("zones.allZones")}</h1>
      <Navigation />
      <div className={styles.profileNavigation}>
        <AssistantShortcut />
        <Notifications />
        <ProfileNavigation />
      </div>
    </div>
  );
}

export { Header };
